/**
 * reducers/roles.ts
 * desc: roles reducers
 */

import type { Reducer } from '@reduxjs/toolkit';
import constants from "../../settings/constants";
import type { RolesAction } from '../actions/roles';
import type { RoleRepresentation } from '../../types/keycloak/roles';

export interface RolesState {
    isLoading: {
        getRoles: boolean;
    };
    list: RoleRepresentation[];
}

const INITIAL_STATE: RolesState = {
    isLoading: {
        getRoles: false,
    },
    list: [],
};

function rolesReducer(state: RolesState = INITIAL_STATE, action: RolesAction): RolesState {
    switch (action.type) {
        // GET Roles (Collection)
        case 'GET_ROLES_ERROR':
            return _getRolesError(state);
        case 'GET_ROLES_REQUEST':
            return _getRolesRequest(state);
        case 'GET_ROLES_SUCCESS':
            return _getRolesSuccess(state, action.payload);

        default:
            return state;
    }
}



//*************************************************
//*****   GET Roles (Collection)   ****************
//*************************************************
function _getRolesError(state: RolesState): RolesState {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            getRoles: false,
        },
    };
}

function _getRolesRequest(state: RolesState): RolesState {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            getRoles: true,
        },
    };
}

function _getRolesSuccess(state: RolesState, payload: RoleRepresentation[]): RolesState {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            getRoles: false,
        },
        list: payload.filter(role => !(constants.HIDDEN_PERMISSIONS as readonly string[]).includes(role.name)),
    };
}



export default rolesReducer as Reducer<RolesState>;
